export enum IntegrationSortingEnum {
  None = 'None',
  Integration = 'Integration',
  IntegrationType = 'IntegrationType',
  IntegrationStatus = 'IntegrationStatus',
}
